(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["klaviyo-form-button"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__klaviyoFormButtonInit) return;
    window.__klaviyoFormButtonInit = true;
    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-klaviyo-form-id]');
      if (!trigger) return;
      var formId = trigger.getAttribute('data-klaviyo-form-id');
      if (!formId) return;
      event.preventDefault();
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
